<div class="passwordInputWrapper">
    <div class="passwordInputContainer" [formGroup]="formGroup">
        <input formControlName="password" [type]="showPassword ? 'text' : 'password'" [id]="id" (blur)="onTouch(true)" #passwordInput />
        <i
            class="icon inputIcon suffix fal fa-xs fa-fw passwordToggle"
            [ngClass]="{ 'fa-eye': showPassword, 'fa-eye-slash': !showPassword }"
            (click)="showPassword = !showPassword"
        >
        </i>
    </div>
    @if (showHints) {
        <div class="passwordValidationContainer">
            <p><i class="info fa fa-info-circle"></i>{{ 'users.onboarding.form.passwordInfoText' | translate }}</p>
            <ul>
                <li>
                    <ul>
                        <li>
                            <i class="fas fa-fw" [ngClass]="{ 'fa-circle': !checks.length, 'fa-circle-check': checks.length }"></i>
                            {{ 'users.onboarding.form.passwordConditions.length' | translate }}
                        </li>
                        <li>
                            <i
                                class="fas fa-fw"
                                [ngClass]="{
                                    'fa-circle': !checks.containDetails.upperCase,
                                    'fa-circle-check': checks.containDetails.upperCase,
                                }"
                            ></i>
                            {{ 'users.onboarding.form.passwordConditions.contain.upper' | translate }}
                        </li>
                        <li>
                            <i
                                class="fas fa-fw"
                                [ngClass]="{
                                    'fa-circle': !checks.containDetails.lowerCase,
                                    'fa-circle-check': checks.containDetails.lowerCase,
                                }"
                            ></i>
                            {{ 'users.onboarding.form.passwordConditions.contain.lower' | translate }}
                        </li>
                        <li>
                            <i
                                class="fas fa-fw"
                                [ngClass]="{ 'fa-circle': !checks.containDetails.number, 'fa-circle-check': checks.containDetails.number }"
                            ></i>
                            {{ 'users.onboarding.form.passwordConditions.contain.number' | translate }}
                        </li>
                        <li>
                            <i
                                class="fas fa-fw"
                                [ngClass]="{ 'fa-circle': !checks.containDetails.symbol, 'fa-circle-check': checks.containDetails.symbol }"
                            ></i>
                            {{ 'users.onboarding.form.passwordConditions.contain.symbol' | translate }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    }
</div>
